// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class NumericNodeId implements flatbuffers.IUnpackableObject<NumericNodeIdT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): NumericNodeId {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsNumericNodeId(bb: flatbuffers.ByteBuffer, obj?: NumericNodeId): NumericNodeId {
    return (obj || new NumericNodeId()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsNumericNodeId(
    bb: flatbuffers.ByteBuffer,
    obj?: NumericNodeId,
  ): NumericNodeId {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new NumericNodeId()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  namespaceIndex(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  identifier(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  static startNumericNodeId(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addNamespaceIndex(builder: flatbuffers.Builder, namespaceIndex: number) {
    builder.addFieldInt16(0, namespaceIndex, 0);
  }

  static addIdentifier(builder: flatbuffers.Builder, identifier: number) {
    builder.addFieldInt32(1, identifier, 0);
  }

  static endNumericNodeId(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createNumericNodeId(
    builder: flatbuffers.Builder,
    namespaceIndex: number,
    identifier: number,
  ): flatbuffers.Offset {
    NumericNodeId.startNumericNodeId(builder);
    NumericNodeId.addNamespaceIndex(builder, namespaceIndex);
    NumericNodeId.addIdentifier(builder, identifier);
    return NumericNodeId.endNumericNodeId(builder);
  }

  unpack(): NumericNodeIdT {
    return new NumericNodeIdT(this.namespaceIndex(), this.identifier());
  }

  unpackTo(_o: NumericNodeIdT): void {
    _o.namespaceIndex = this.namespaceIndex();
    _o.identifier = this.identifier();
  }

  unpackFields(...fields: string[]): NumericNodeIdT {
    const t = new NumericNodeIdT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("namespace_index")) {
      t.namespaceIndex = this.namespaceIndex();
    }
    if (fieldSet.has("identifier")) {
      t.identifier = this.identifier();
    }
    return t;
  }
}

export class NumericNodeIdT implements flatbuffers.IGeneratedObject {
  constructor(
    public namespaceIndex: number = 0,
    public identifier: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return NumericNodeId.createNumericNodeId(builder, this.namespaceIndex, this.identifier);
  }

  clone(): NumericNodeIdT {
    const obj = new NumericNodeIdT();
    obj.namespaceIndex = this.namespaceIndex;
    obj.identifier = this.identifier;
    return obj;
  }

  equals(other: NumericNodeIdT): boolean {
    if (this.namespaceIndex !== other.namespaceIndex) return false;
    if (this.identifier !== other.identifier) return false;
    return true;
  }
}

export function verifyNumericNodeId(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
    verifier.checkScalarField(tablePos, 6, 4);
  } finally {
    verifier.popDepth();
  }
}
